<template>
  <b-container
    class="mb-5"
    fluid
  >
    <div class="d-flex justify-content-end mb-3">
      <b-breadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <b-card>
      <b-row class="mb-2 px-2">

        <b-col
          cols="12"
          class="px-1"
        >
          <b-form-group>
            <label
              for="filter_search"
            >
              <strong>
                Search
              </strong>
            </label>
            <b-input
              id="filter_search"
              v-model="tableTypes.filter"
              type="text"
              placeholder="search here"
              debounce="1000"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          class="px-1"
        >
          <b-button
            type="button"
            variant="primary"
            @click="onShowAddFormType"
          >
            Add Type
          </b-button>
        </b-col>

      </b-row>

      <b-table
        ref="tableTypes"
        hover
        responsive
        show-empty
        class="mt-2"
        :per-page="tableTypes.perPage"
        :current-page="tableTypes.currentPage"
        :items="myProvider"
        :fields="tableTypes.fields"
        :sort-by.sync="tableTypes.sortBy"
        :sort-desc.sync="tableTypes.sortDesc"
        :sort-direction="tableTypes.sortDirection"
        :filter="tableTypes.filter"
        :filter-included-fields="tableTypes.filterOn"
      >
        <template #cell(index)="row">
          {{ tableTypes.currentPage * tableTypes.perPage - tableTypes.perPage + (row.index + 1) }}
        </template>

        <template #cell(active)="row">
          {{ row.item.active == 1 ? 'Yes' : 'No' }}
        </template>

        <template #cell(type_name)="row">
          <div class="text-nowrap">
            <strong>{{ row.value }}</strong>
          </div>
        </template>

        <template #cell()="row">
          <div class="text-nowrap">
            {{ row.value }}
          </div>
        </template>

        <template #cell(action)="row">
          <div class="text-nowrap">
            <b-button
              size="sm"
              @click="onShowEditFormType(row.item)"
            >
              Edit
            </b-button>
          </div>
        </template>

      </b-table>

      <b-row>
        <b-col
          cols="12"
          sm="6"
        >
          <div class="w-100 w-sm-25 mb-2 sm-mb-2">
            <b-select
              v-model="tableTypes.perPage"
              :options="tableTypes.pageOptions"
              size="sm"
            />
          </div>
        </b-col>
        <b-col
          cols="12"
          sm="6"
          class="d-flex justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="tableTypes.currentPage"
            :total-rows="tableTypes.totalRows"
            :per-page="tableTypes.perPage"
            first-number
            last-number
            pills
            prev-text="Prev"
            next-text="Next"
            aria-controls="table"
          />
        </b-col>
      </b-row>
    </b-card>

    <b-modal
      id="modal-type"
      scrollable
      no-close-on-backdrop
      :title="modalTypeTitle"
      aria-hidden="false"
      @ok="onValidateFormType"
    >
      <ValidationObserver
        ref="formType"
      >
        <form
          novalidate
          @submit.prevent
        >
          <ValidationProvider
            #default="{ errors }"
            name="type name"
            vid="type_name"
            rules="required|max:100"
          >
            <b-form-group>
              <label for="type_name">
                <strong>
                  Type
                </strong>
              </label>
              <b-input
                id="type_name"
                v-model="type.type_name"
                type="text"
                :state="errors.length > 0 ? false : null"
                placeholder="enter type name"
                autocomplete="off"
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <div
            v-if="state.editing"
            class="form-group"
          >
            <b-form-checkbox
              id="is_active"
              v-model="type.active"
              name="is_active"
              value="1"
              unchecked-value="0"
              :disabled="state.busy"
              switch
            >
              Is Active?
            </b-form-checkbox>
          </div>

        </form>
      </ValidationObserver>

      <template #modal-footer="{ok, cancel}">
        <b-button
          variant="success"
          :disabled="state.busy"
          @click="ok()"
        >
          {{ state.editing ? 'Update Record' : 'Save Record' }}
        </b-button>
        <b-button
          variant="danger"
          :disabled="state.busy"
          @click="cancel()"
        >
          Close Window
        </b-button>
      </template>

    </b-modal>
  </b-container>
</template>
<script>
import _ from 'lodash'
import { core } from '@/config/pluginInit'
import { AdminTypeService } from '@/services'
import formatter from '@/mixins/formatter'

export default {
  name: 'AdminTypes',

  middleware: ['auth', 'admin'],

  metaInfo () {
    return {
      title: 'Types'
    }
  },

  mixins: [formatter],

  data () {
    return {
      state: {
        busy: false,
        editing: false
      },
      type: {
        id: null,
        type_name: null,
        active: 0
      },
      tableTypes: {
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        totalRows: 0,
        currentPage: 1,
        sortBy: null,
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
        fields: [
          { key: 'index', class: 'text-center' },
          { key: 'action', class: 'text-center' },
          { key: 'type_name', label: 'type', sortable: true },
          { key: 'active', class: 'text-center' },
          { key: 'updated_at', formatter: this.dateTimeShortFormatter }
        ]
      }
    }
  },

  computed: {
    modalTypeTitle () {
      return this.state.editing ? 'Edit Type' : 'Add Type'
    }
  },

  mounted () {
    core.index()
  },

  methods: {

    async myProvider (ctx) {
      return await AdminTypeService.get(
        this.objectToUrl({
          page: ctx.currentPage,
          per_page: ctx.perPage,
          sort: ctx.sortBy,
          sort_desc: ctx.sortDesc,
          filter_text: ctx.filter
        })
      ).then(({ data }) => {
        this.tableTypes.totalRows = data.total_rows
        return data.items
      }).catch(() => {
        return []
      })
    },

    onShowAddFormType () {
      this.state.editing = false
      this.type.id = null
      this.type.type_name = null
      this.type.active = 1
      this.$bvModal.show('modal-type')
    },

    onShowEditFormType (type) {
      this.state.editing = true
      this.type.id = type.id
      this.type.type_name = type.type_name
      this.type.active = type.active
      this.$bvModal.show('modal-type')
    },

    async onValidateFormType (bvModalEvt) {
      bvModalEvt.preventDefault()
      await this.$refs.formType.validate().then(async success => {
        if (success) {
          let text = 'Do you really want to create type?'
          if (this.state.editing) {
            text = 'Do you really want to save changes?'
          }
          this.$swal.fire({
            icon: 'question',
            title: 'Question',
            text: text,
            confirmButtonColor: '#06C270',
            confirmButtonText: 'Yes',
            cancelButtonColor: '#FF2929',
            showCancelButton: true,
            showLoaderOnConfirm: true,
            preConfirm: () => {
              this.state.busy = false
              if (this.state.editing) {
                return this.onPutFormType()
              } else {
                return this.onPostFormType()
              }
            },
            allowOutsideClick: () => !this.$swal.isLoading()
          })
        } else {
          this.$bvModal.msgBoxOk(
            'Oops! There were problem with your inputs.', {
              title: 'Validation Error',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'danger',
              centered: true
            }
          )
        }
      })
    },

    async onPostFormType () {
      return new Promise(resolve => {
        AdminTypeService.post(this.type).then(({ data }) => {
          this.state.busy = false
          this.$bvModal.hide('modal-type')
          this.$swal.fire({
            icon: 'success',
            title: 'Successful',
            text: data.message,
            confirmButtonColor: '#06C270',
            confirmButtonText: 'Dismiss'
          }).then(() => {
            this.$refs.tableTypes.refresh()
          })
        }).catch(error => {
          this.state.busy = false
          this.$refs.formType.setErrors(error.message)
          resolve(error)
        })
      })
    },

    async onPutFormType () {
      return new Promise(resolve => {
        AdminTypeService.put(this.type).then(({ data }) => {
          this.$bvModal.hide('modal-type')
          this.state.busy = false
          this.$swal.fire({
            icon: 'success',
            title: 'Successful',
            text: data.message,
            confirmButtonColor: '#06C270',
            confirmButtonText: 'Dismiss'
          }).then(() => {
            const row = _.find(this.$refs.tableTypes.localItems, { id: data.type.id })
            row.type_name = data.type.type_name
            row.active = data.type.active
            row.updated_at = data.type.updated_at
          })
        }).catch(error => {
          this.state.busy = false
          this.$refs.formType.setErrors(error.message)
          resolve(error)
        })
      })
    }
  }
}
</script>
